<template>
  <main class="feedback-page">
    <section class="feedback-card">
      <header class="feedback-header">
        <div class="feedback-brand">
          <span class="feedback-brand-mark"><img src="@/assets/v2/img/index/wiseivy-mark.png" alt=""></span>
          <span>微思学术</span>
        </div>
        <div class="feedback-heading">
          <span class="feedback-eyebrow">FEEDBACK</span>
          <h1>意见反馈</h1>
          <p>欢迎留下宝贵建议，我们会认真阅读并持续改进。</p>
        </div>
      </header>

      <el-form
        ref="jianyiRef"
        class="feedback-form"
        :model="from"
        :rules="login_rules"
        label-position="top"
      >
        <el-form-item prop="recommendation" label="您的意见">
          <el-input
            v-model="from.recommendation"
            rows="4"
            type="textarea"
            placeholder="请按照各单位图书馆上的使用通知或指南进行账号注册及使用，如有其他问题，可在此留言。"
            resize="none"
            maxlength="200"
            show-word-limit
          >
          </el-input>
        </el-form-item>

        <div class="contact-heading">
          <strong>联系方式</strong>
          <span>请留下有效信息，以便我们与您联系。</span>
        </div>

        <div class="contact-grid">
          <el-form-item prop="realname" label="姓名">
            <el-input v-model="from.realname" placeholder="请输入姓名"></el-input>
          </el-form-item>
          <el-form-item prop="phone" label="电话">
            <el-input v-model="from.phone" placeholder="请输入电话"></el-input>
          </el-form-item>
          <el-form-item prop="unit" label="单位">
            <el-input v-model="from.unit" placeholder="请输入单位"></el-input>
          </el-form-item>
          <el-form-item label="邮箱">
            <el-input v-model="from.email" placeholder="请输入邮箱" type="email"></el-input>
          </el-form-item>
        </div>

        <el-form-item class="feedback-submit">
          <el-button
            type="primary"
            data-track-text="提交意见反馈"
            aria-label="提交意见反馈"
            @click="submitJianyiFrom()"
          >提交意见</el-button>
        </el-form-item>
      </el-form>
    </section>
  </main>
</template>

<script>
import { recommendationsRequest, authServiceClient } from '../tools/api/auth-api'

export default {
  name: 'Recommendations',
  data () {
    const checkPhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入您的手机号'))
      }
      const regs = /^[1][3,4,5,7,8][0-9]{9}$/
      if (!regs.test(value)) {
        // Keep the existing Element Form validator payload unchanged.
        // eslint-disable-next-line standard/no-callback-literal
        return callback([new Error('请输入合法的手机号')])
      } else {
        return callback()
      }
    }
    return {
      timer: '',
      from: {
        recommendation: '',
        realname: '',
        email: '',
        phone: '',
        unit: ''
      },
      login_rules: {
        unit: [
          { required: true, message: '请输入您的机构', trigger: 'blur' }
        ],
        realname: [
          { required: true, message: '请输入您的姓名', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入您的手机号', trigger: 'blur' },
          { validator: checkPhone, trigger: 'blur' }
        ],
        recommendation: [
          { required: true, message: '请输入您的意见', trigger: 'blur' },
          { min: 10, max: 200, message: '为了更加理解您提出的意见，期望您的描述在10~200个字符之间', trigger: 'blur' }
        ]
      }
    }
  },
  beforeDestroy () {
    clearTimeout(this.timer)
  },
  methods: {
    submitJianyiFrom () {
      const that = this
      this.$refs.jianyiRef.validate((valid) => {
        if (!valid) {
          return false
        }
        const request = recommendationsRequest
        request.setUnit(that.from.unit)
        request.setEmail(that.from.email)
        request.setPhone(that.from.phone)
        request.setRealName(that.from.realname)
        request.setRecommendation(that.from.recommendation)
        const TOKEN_KEY = 'token'
        const metadata = {
          [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
        }
        authServiceClient.recommendations(request, metadata).then(res => {
          if (res.getStatus()) {
            that.$message({
              center: true,
              type: 'success',
              showClose: true,
              duration: 3000,
              message: res.getMessage()
            })
            this.timer = setTimeout(() => {
              window.parent.postMessage({
                data: 'close'
              }, '*')
            }, 3000)
            return
          }
          that.$message({
            center: true,
            type: 'error',
            showClose: true,
            duration: 3000,
            message: res.getMessage()
          })
          window.parent.postMessage({
            data: 'close'
          }, '*')
        }).catch(() => {
          that.$message({
            center: true,
            type: 'error',
            showClose: true,
            duration: 3000,
            message: '提交意见失败，请稍后再试!'
          })
          window.parent.postMessage({
            data: 'close'
          }, '*')
        })
      })
    }
  }
}
</script>

<style lang="less" scoped>
.feedback-page {
  position: fixed;
  inset: 0;
  padding: 0;
  overflow: auto;
  box-sizing: border-box;
  color: #1a1a2e;
  background:
    radial-gradient(circle at 8% 0, rgba(16, 185, 129, .18), transparent 34%),
    linear-gradient(145deg, var(--primary-light) 0%, var(--bg-page) 56%, var(--primary-alpha-08) 100%);
  font-family: "Noto Sans SC", "Microsoft YaHei", sans-serif;
}

.feedback-card {
  width: 100%;
  max-width: none;
  min-height: 100%;
  margin: 0;
  overflow: hidden;
  box-sizing: border-box;
  border: 1px solid rgba(5, 150, 105, .10);
  border-radius: 24px;
  background: #fff;
  box-shadow: 0 18px 48px rgba(0, 0, 0, .14);
}

.feedback-header {
  position: relative;
  min-height: 104px;
  padding: 22px 34px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 36px;
  overflow: hidden;
  box-sizing: border-box;
  color: #fff;
  background: var(--primary-gradient);
}

.feedback-header::after {
  content: '';
  position: absolute;
  right: -35px;
  bottom: -70px;
  width: 210px;
  height: 210px;
  border: 32px solid rgba(255, 255, 255, .08);
  border-radius: 50%;
}

.feedback-brand,
.feedback-heading {
  position: relative;
  z-index: 1;
}

.feedback-brand {
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 0 0 auto;
  font-size: 17px;
  font-weight: 700;
}

.feedback-brand-mark {
  width: 38px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background: rgba(255, 255, 255, .96);
}

.feedback-brand img {
  width: 30px;
  height: 30px;
  display: block;
  object-fit: contain;
}

.feedback-heading {
  flex: 1;
  text-align: right;
}

.feedback-eyebrow {
  display: block;
  margin-bottom: 2px;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 2px;
  opacity: .72;
}

.feedback-heading h1 {
  margin: 0;
  font-size: 23px;
  line-height: 32px;
}

.feedback-heading p {
  margin: 3px 0 0;
  font-size: 12px;
  opacity: .82;
}

.feedback-form {
  padding: 18px 34px 20px;
}

.contact-heading {
  margin: 2px 0 10px;
  display: flex;
  align-items: baseline;
  gap: 12px;
}

.contact-heading strong {
  color: #1f2937;
  font-size: 15px;
}

.contact-heading span {
  color: #7a8794;
  font-size: 12px;
}

.contact-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0 20px;
}

/deep/ .el-form-item {
  margin-bottom: 12px;
}

/deep/ .el-form-item__label {
  padding: 0 0 5px;
  color: #3d4b5c;
  font-size: 13px;
  font-weight: 600;
  line-height: 18px;
}

/deep/ .el-input__inner,
/deep/ .el-textarea__inner {
  width: 100%;
  box-sizing: border-box;
  color: #263444;
  border: 1px solid #d5e0ec;
  border-radius: 8px;
  background: #f9fbfd;
  box-shadow: none;
  font-family: inherit;
  transition: border-color .18s, box-shadow .18s, background .18s;
}

/deep/ .el-input__inner {
  height: 40px !important;
  font-size: 14px;
}

/deep/ .el-textarea__inner {
  height: 104px;
  min-height: 104px !important;
  padding: 10px 13px 24px;
  overflow-y: auto;
  font-size: 14px;
  line-height: 21px;
}

/deep/ .el-input__inner:focus,
/deep/ .el-textarea__inner:focus {
  border-color: var(--primary);
  background: #fff;
  box-shadow: 0 0 0 3px rgba(0, 0, 0, .10);
}

/deep/ .el-textarea .el-input__count {
  right: 12px;
  bottom: 7px;
  color: #8a97a5;
  background: transparent;
  font-size: 11px;
}

/deep/ .el-form-item.is-error .el-input__inner,
/deep/ .el-form-item.is-error .el-input__inner:focus,
/deep/ .el-form-item.is-error .el-textarea__inner,
/deep/ .el-form-item.is-error .el-textarea__inner:focus {
  border-color: #e45b65 !important;
}

/deep/ .el-form-item__error {
  padding-top: 2px;
  color: #d93645;
  font-size: 11px;
}

.feedback-submit {
  margin: 2px 0 0 !important;
}

.feedback-submit /deep/ .el-form-item__content {
  margin: 0 !important;
}

.feedback-submit /deep/ .el-button {
  width: 100%;
  height: 42px;
  color: #fff;
  border: 0;
  border-radius: 8px;
  background: var(--primary-gradient);
  box-shadow: 0 8px 18px rgba(0, 0, 0, .18);
  font-size: 15px;
  font-weight: 600;
}

.feedback-submit /deep/ .el-button:hover,
.feedback-submit /deep/ .el-button:focus {
  background: var(--primary-gradient);
}

@media (max-width: 680px) {
  .feedback-page {
    padding: 0;
  }

  .feedback-header {
    min-height: 92px;
    padding: 18px 20px;
    gap: 16px;
  }

  .feedback-heading p {
    display: none;
  }

  .feedback-form {
    padding: 16px 20px 20px;
  }

  .contact-grid {
    grid-template-columns: 1fr;
  }

  .contact-heading {
    display: block;
  }

  .contact-heading span {
    display: block;
    margin-top: 3px;
  }
}
</style>
